<template>
	<v-container fluid class="mt-0 pt-0">
		<v-row class="px-3">
			<v-col cols="6">
				<div
					class="module-top-info"
					v-if="member.id != null && member.id != undefined && member.id !== 0 && member.id !== '0'"
				>
					<span class="module-top-name">{{ member.last_name }}&nbsp;{{ member.first_name }}</span>
					<span v-if="member.branch != null && member.branch != undefined" class="module-top-branch">{{
						member.branch.name
					}}</span>
					<span
						v-if="member.membership_id != null && member.membership_id != undefined"
						class="module-top-membership-id"
						>Čl. broj: <b>{{ member.membership_id }}</b></span
					>
					<span
						v-if="member.membership_status != null && member.membership_status != undefined"
						class="module-top-status"
						>Status: <b>{{ member.membership_status.name }}</b></span
					>
				</div>
				<div v-else>
					<span class="module-top-name">{{ $t('labels.memberNew') }}</span>
				</div>
			</v-col>
			<v-col cols="6" class="d-flex justify-end" v-if="$myStore.state.user.user_role_id == 1">
				<v-btn
					v-if="member.id != null && member.id != 0 && inEditMode === false"
					class="mr-3"
					color="primary"
					@click="inEditMode = true"
					>Uredi</v-btn
				>
				<v-btn v-else class="mr-3" color="primary" @click="saveClick">Spremi</v-btn>
				<v-btn v-if="inEditMode === false || member.id == '0'" @click="backClick">Natrag</v-btn>
				<v-btn v-else @click="cancelEditClick">Odustani</v-btn>
			</v-col>
			<v-col cols="6" class="d-flex justify-end" v-else>
				<v-btn @click="backClick">Natrag</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-tabs left color="primary" v-model="tabId">
				<v-tab class="module-tab"> {{ $t('tabs.memberPersonalInfo') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.memberContactInfo') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.memberEmploymentInfo') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.memberMembershipInfo') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.memberResponsibilities') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.memberPayments') }} </v-tab>
				<v-tab class="module-tab"> {{ $t('tabs.memberBookstore') }} </v-tab>
				<v-tab
					class="module-tab"
					:disabled="
						member.id != null && member.id != undefined && member.id !== 0 && member.id !== '0'
							? false
							: true
					"
				>
					{{ $t('tabs.memberEditHistory') }}
				</v-tab>
				<v-tab-item>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.oib"
									:label="$t('fields.oib')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.first_name"
									:label="'* ' + $t('fields.firstName')"
									:errorBorder="!memberValidation.first_name"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.last_name"
									:label="'* ' + $t('fields.lastName')"
									:errorBorder="!memberValidation.last_name"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.gender"
									:ajax="false"
									:data="genders"
									:errorBorder="!memberValidation.gender"
									:label="'* ' + $t('fields.gender')"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:disabled="!inEditMode"
									v-model="member.date_of_birth"
									:dateLabel="'* ' + $t('fields.dateOfBirth')"
									:errorBorder="!memberValidation.date_of_birth"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.place_of_birth"
									:label="'* ' + $t('fields.placeOfBirth')"
									:errorBorder="!memberValidation.place_of_birth"
								></InputField>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:disabled="!inEditMode"
									v-model="member.nationality_id"
									:label="$t('fields.nationality')"
									:ajax="true"
									:data="'nationalities'"
									:key="codebookDropdownKey"
								></Dropdown>
								<v-icon small class="ml-2 add-icon" @click="newCodebookEntryAddClick('nationalities')"
									>fa-add</v-icon
								>
							</v-row>
							<!-- <v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.profession_id"
									:label="$t('fields.profession')"
									:errorBorder="!memberValidation.profession_id"
									:ajax="true"
									:data="'professions'"
									:key="codebookDropdownKey"
								></Dropdown>
								<v-icon small class="ml-2 add-icon" @click="newCodebookEntryAddClick('professions')"
									>fa-add</v-icon
								>
							</v-row> -->
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:disabled="!inEditMode"
									v-model="member.qualification_id"
									:label="$t('fields.qualification')"
									:ajax="true"
									:data="'qualifications'"
									:key="codebookDropdownKey"
								></Dropdown>
								<v-icon small class="ml-2 add-icon" @click="newCodebookEntryAddClick('qualifications')"
									>fa-add</v-icon
								>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:disabled="!inEditMode"
									v-model="member.academic_title_id"
									:label="$t('fields.academicTitle')"
									:ajax="true"
									:data="'academic-titles'"
									:key="codebookDropdownKey"
								></Dropdown>
								<v-icon small class="ml-2 add-icon" @click="newCodebookEntryAddClick('academic_titles')"
									>fa-add</v-icon
								>
							</v-row>
							<v-row class="ma-1 mb-2 pr-5" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.profession"
									:label="$t('fields.profession')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2 pr-5" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.occupation"
									:label="$t('fields.occupation')"
								></InputField>
							</v-row>
						</v-col>
					</v-row>
					<v-row class="pt-3 px-md-5 px-7 mx-md-1" :class="!inEditMode ? 'read-only-class' : ''">
						<TextArea :disabled="!inEditMode" v-model="member.note" :label="$t('fields.note')"></TextArea>
					</v-row>
					<v-dialog v-model="newCodebookEntryShow" persistent width="30%">
						<v-card>
							<v-col class="pa-5">
								<v-row class="px-3 mb-3">
									<InputField
										v-model="newCodebookEntryValue"
										:label="$t('fields.value')"
									></InputField>
								</v-row>
								<v-row class="px-3 justify-center">
									<v-btn @click="newCodebookEntrySave" color="primary">Dodaj</v-btn>
									<v-spacer></v-spacer>
									<v-btn @click="newCodebookEntryClose">Odustani</v-btn>
								</v-row>
							</v-col>
						</v-card>
					</v-dialog>
				</v-tab-item>
				<v-tab-item>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.address"
									:label="$t('fields.address')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.zip_code"
									:label="'* ' + $t('fields.zipCode')"
									:errorBorder="!memberValidation.zip_code"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.city"
									:label="'* ' + $t('fields.city')"
									:errorBorder="!memberValidation.city"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.country_id"
									:ajax="true"
									:data="'countries'"
									:errorBorder="!memberValidation.country_id"
									:label="'* ' + $t('fields.country')"
								></Dropdown>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.phone_number"
									:label="$t('fields.phoneNumber')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.mobile_phone_number"
									:label="$t('fields.mobilePhoneNumber')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.email"
									:label="$t('fields.email')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<v-radio-group
									row
									dense
									class="mt-1"
									:disabled="!inEditMode"
									v-model="member.newsletter_signup"
									:label="$t('fields.newsletterSignup')"
								>
									<v-radio label="Da" :value="true"></v-radio>
									<v-radio label="Ne" :value="false"></v-radio>
								</v-radio-group>
							</v-row>
						</v-col>
					</v-row>
					<v-row class="pl-2 pl-md-0 pt-2 ml-0">
						<span class="module-title"> Dodatna adresa (za časopis) </span>
					</v-row>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.magazine_address"
									:label="$t('fields.address')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.magazine_zip_code"
									:label="$t('fields.zipCode')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.magazine_city"
									:label="$t('fields.city')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:disabled="!inEditMode"
									v-model="member.magazine_country_id"
									:ajax="true"
									:data="'countries'"
									:label="$t('fields.country')"
								></Dropdown>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<TextArea
									:disabled="!inEditMode"
									v-model="member.magazine_note"
									:label="$t('fields.note')"
								></TextArea>
							</v-row>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.company"
									:label="$t('fields.company')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.company_address"
									:label="$t('fields.address')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.company_city"
									:label="$t('fields.city')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.company_zip_code"
									:label="$t('fields.zipCode')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:disabled="!inEditMode"
									v-model="member.company_country_id"
									:ajax="true"
									:data="'countries'"
									:label="$t('fields.country')"
								></Dropdown>
							</v-row>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.membership_id"
									:label="'* ' + $t('fields.membershipId')"
									:errorBorder="!memberValidation.membership_id"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.membership_start_date_id"
									:ajax="true"
									:data="'membership-start-dates'"
									:label="'* ' + $t('fields.membershipStartDate')"
									:errorBorder="!memberValidation.membership_start_date_id"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : 'read-only-class'">
								<InputField
									:disabled="true"
									v-model="member.reference_number"
									:label="$t('fields.referenceNumber')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.membership_type_id"
									:ajax="true"
									:data="'membership-types'"
									:label="'* ' + $t('fields.membershipType')"
									:errorBorder="!memberValidation.membership_type_id"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:clearable="inEditMode"
									:disabled="!inEditMode"
									v-model="member.membership_special_status_id"
									:ajax="true"
									:data="'membership-special-statuses'"
									:label="$t('fields.membershipSpecialStatus')"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.membership_status_id"
									:ajax="true"
									:data="'membership-statuses'"
									:label="'* ' + $t('fields.membershipStatus')"
									:errorBorder="!memberValidation.membership_status_id"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.branch_id"
									:ajax="true"
									:data="'branches'"
									:label="'* ' + $t('fields.membershipBranch')"
									:errorBorder="!memberValidation.branch_id"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2 read-only-class">
								<DatePicker
									:disabled="true"
									v-model="member.membership_valid_until_date"
									:dateLabel="$t('fields.membershipValidUntil')"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2 read-only-class">
								<DatePicker
									:disabled="true"
									v-model="member.postage_valid_until_date"
									:dateLabel="$t('fields.postageValidUntil')"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:disabled="!inEditMode"
									v-model="member.membership_paid_until_date"
									:dateLabel="$t('fields.membershipPaidUntil')"
								></DatePicker>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<v-radio-group
									row
									dense
									class="mt-1 mb-2"
									hide-details
									:disabled="!inEditMode"
									v-model="member.member_withdrawn"
									:label="$t('fields.memberWithdrawn')"
								>
									<v-radio label="Da" :value="true"></v-radio>
									<v-radio label="Ne" :value="false"></v-radio>
								</v-radio-group>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:disabled="!inEditMode"
									v-model="member.member_withdrawal_date"
									:dateLabel="$t('fields.memberWithdralDate')"
								></DatePicker>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<v-radio-group
									row
									dense
									class="mt-1 mb-2"
									:disabled="!inEditMode"
									v-model="member.member_deceased"
									:label="$t('fields.memberDeceased')"
									hide-details
								>
									<v-radio label="Da" :value="true"></v-radio>
									<v-radio label="Ne" :value="false"></v-radio>
								</v-radio-group>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<InputField
									:disabled="!inEditMode"
									v-model="member.member_decease_date"
									:label="$t('fields.memberDeceaseDate')"
								></InputField>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<TextArea
									:rows="4"
									:disabled="!inEditMode"
									v-model="member.membership_note"
									:label="$t('fields.membershipNote')"
								></TextArea> </v-row
							><v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<Dropdown
									:disabled="!inEditMode"
									v-model="member.magazine_id"
									:ajax="true"
									:data="'magazines'"
									:label="'* ' + $t('fields.subscription')"
									:errorBorder="!memberValidation.magazine_id"
								></Dropdown>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<CheckBox
									class="mt-1 mb-2"
									:readonly="!inEditMode"
									v-model="member.magazine_bookstore_delivery"
									:label="$t('fields.magazineBookstoreDelivery')"
								></CheckBox>
							</v-row>
							<v-row
								class="ma-1 mb-2"
								v-if="
									member.functions !== undefined &&
									member.functions !== null &&
									member.functions.length > 0
								"
							>
								<v-col cols="12" class="ma-0 pa-0">
									<div class="mt-2 member-functions-title">Funkcije:</div>
									<div
										class="d-block member-functions-entry"
										v-for="entry in member.functions"
										:key="entry.id"
										@click="routeToBranch(entry.branch_id)"
									>
										&#x2022;&nbsp;{{ entry.function }}
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<v-radio-group
									row
									dense
									class="mt-1"
									:disabled="!inEditMode"
									v-model="member.card_issued"
									:label="'* ' + $t('fields.cardIssued')"
									:errorBorder="!memberValidation.card_issued"
								>
									<v-radio label="Da" :value="true"></v-radio>
									<v-radio label="Ne" :value="false"></v-radio>
								</v-radio-group>
							</v-row>
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<DatePicker
									:disabled="!inEditMode"
									v-model="member.membership_start_date_value"
									:dateLabel="'* ' + $t('fields.cardIssueDate')"
									:errorBorder="!memberValidation.membership_start_date_value"
								></DatePicker>
							</v-row>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 py-0">
							<v-row class="ma-1 mb-2" :class="!inEditMode ? 'read-only-class' : ''">
								<v-radio-group
									row
									dense
									class="mt-1"
									:disabled="!inEditMode"
									v-model="member.payment_form_by_email"
									:label="'* ' + $t('fields.paymentFormByEmail')"
									:errorBorder="!memberValidation.payment_form_by_email"
								>
									<v-radio label="Da" :value="true"></v-radio>
									<v-radio label="Ne" :value="false"></v-radio>
								</v-radio-group>
							</v-row>
						</v-col>
					</v-row>
					<v-row class="pt-3 px-md-5 px-7 mx-md-1" :class="!inEditMode ? 'read-only-class' : ''">
						<TextArea
							:disabled="!inEditMode"
							v-model="member.payment_note"
							:label="$t('fields.paymentNote')"
						></TextArea>
					</v-row>
					<v-row class="pa-4">
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text>
									<v-row>
										<v-col>
											<TheTable
												:additional-filters="paymentFormsTable.additionalFilters"
												:default-sort="paymentFormsTable.defaultSort"
												:fields="paymentFormsTable.headers"
												:filter-save-key="'member-payment-forms-filters'"
												:height="paymentFormsTable.height"
												:total-records="paymentFormsTable.total"
												@headers="selectPaymentFormsHeaders"
												@reload="reloadPaymentFormsData"
											>
												<tr
													v-for="(item, key) in paymentFormsTable.items"
													:key="key"
													:class="{ 'cursor-pointer': true }"
													@contextmenu.prevent="editPaymentFormsClick(props.item.id, true)"
												>
													<td
														v-if="paymentFormsTable.selectedHeaders.includes('date')"
														@click="editPaymentFormsClick(item.id, false)"
													>
														{{ item.date_display }}
													</td>
													<td
														v-if="paymentFormsTable.selectedHeaders.includes('category')"
														@click="editPaymentFormsClick(item.id, false)"
													>
														{{ item.payment_category.name }}
													</td>
													<td
														v-if="
															paymentFormsTable.selectedHeaders.includes(
																'reference_number'
															)
														"
														@click="editPaymentFormsClick(item.id, false)"
													>
														{{ item.reference_number }}
													</td>
													<td
														v-if="paymentFormsTable.selectedHeaders.includes('amount')"
														@click="editPaymentFormsClick(item.id, false)"
													>
														{{ item.amount }}
													</td>
													<td v-if="paymentFormsTable.selectedHeaders.includes('returned')">
														<v-icon
															@click="updatePaymentStatus(item)"
															style="cursor: pointer"
															v-if="item.returned"
															color="red"
															>fa-rotate-left</v-icon
														>
														<v-icon
															@click="updatePaymentStatus(item)"
															style="cursor: pointer"
															v-else
															color="gray--lighen-1"
															>fa-rotate-left</v-icon
														>
													</td>
												</tr>
											</TheTable>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="pa-4">
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text>
									<v-row>
										<v-col>
											<TheTable
												:additional-filters="paymentsTable.additionalFilters"
												:default-sort="paymentsTable.defaultSort"
												:fields="paymentsTable.headers"
												:filter-save-key="'member-payments-filters'"
												:height="paymentsTable.height"
												:total-records="paymentsTable.total"
												@headers="selectPaymentHeaders"
												@reload="reloadPaymentData"
											>
												<tr
													v-for="(item, key) in paymentsTable.items"
													:key="key"
													:class="{ 'cursor-pointer': true }"
													@contextmenu.prevent="editPaymentClick(props.item.id, true)"
												>
													<td
														v-if="paymentsTable.selectedHeaders.includes('date')"
														@click="editClick(item.id, false)"
													>
														{{ item.payment_form_date_display }}
													</td>
													<td
														v-if="
															paymentsTable.selectedHeaders.includes('reference_number')
														"
														@click="editClick(item.id, false)"
													>
														<span v-if="item.reference_number">{{
															item.reference_number
														}}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="paymentsTable.selectedHeaders.includes('category')"
														@click="editClick(item.id, false)"
													>
														<span v-if="item.payment_category">{{
															item.payment_category.name
														}}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="
															paymentsTable.selectedHeaders.includes(
																'payment_form_amount'
															)
														"
														@click="editClick(item.id, false)"
													>
														{{ item.payment_form_amount }}
													</td>
													<td
														v-if="paymentsTable.selectedHeaders.includes('payment_amount')"
														@click="editClick(item.id, false)"
													>
														{{ item.amount }}
													</td>
													<td
														v-if="paymentsTable.selectedHeaders.includes('payment_date')"
														@click="editClick(item.id, false)"
													>
														{{ item.date_display }}
													</td>
													<td
														v-if="paymentsTable.selectedHeaders.includes('excerpt')"
														@click="editClick(item.id, false)"
													>
														{{ item.excerpt_number }}
													</td>
												</tr>
											</TheTable>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="pa-4">
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text>
									<v-row>
										<v-col>
											<TheTable
												:additional-filters="subscriptionsTable.additionalFilters"
												:default-sort="subscriptionsTable.defaultSort"
												:fields="subscriptionsTable.headers"
												:filter-save-key="'member-supscriptions-filters'"
												:height="subscriptionsTable.height"
												:total-records="subscriptionsTable.total"
												@headers="selectSubscriptionHeaders"
												@reload="reloadSubscriptionData"
											>
												<tr
													v-for="(item, key) in subscriptionsTable.items"
													:key="key"
													:class="{ 'cursor-pointer': true }"
													@contextmenu.prevent
												>
													<td
														v-if="subscriptionsTable.selectedHeaders.includes('date')"
													>
														{{ item.date_display }}
													</td>
													<td
														v-if="
															subscriptionsTable.selectedHeaders.includes('magazine_id')
														"
													>
														{{ item.magazine_name }}
													</td>
													<td
														v-if="
															subscriptionsTable.selectedHeaders.includes('title')
														"
													>
														<span v-if="item.subscription.title">{{ item.subscription.title }}</span>
														<span v-else>-</span>
													</td>
													<td
														v-if="
															subscriptionsTable.selectedHeaders.includes(
																'delivery_type_id'
															)
														"
													>
														{{ item.delivery_type.name }}
													</td>
													<td
														v-if="subscriptionsTable.selectedHeaders.includes('collected')"
														@click="toggleCollected(item)"
													>
														<v-icon v-if="item.collected == 1" color="primary">fas fa-square-check</v-icon>
														<v-icon v-else>far fa-square</v-icon>
													</td>
												</tr>
											</TheTable>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
					<v-row class="px-3 pt-3">
						<v-col cols="12" md="6" class="px-md-5 mb-2 py-0" :class="!inEditMode ? 'read-only-class' : ''">
							<TextArea
								:disabled="!inEditMode"
								v-model="member.withdrawn_books_note"
								:label="$t('fields.withdrawnBooksNote')"
							></TextArea>
						</v-col>
						<v-col cols="12" md="6" class="px-md-5 mb-2 py-0" :class="!inEditMode ? 'read-only-class' : ''">
							<TextArea
								:disabled="!inEditMode"
								v-model="member.returned_subscriptions_note"
								:label="$t('fields.returnedSubscriptions')"
							></TextArea>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item>
					<v-row class="pa-4">
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text>
									<v-row>
										<v-col>
											<TheTable
												:additional-filters="memberLogTable.additionalFilters"
												:default-sort="memberLogTable.defaultSort"
												:fields="memberLogTable.headers"
												:filter-save-key="'member-log-filters'"
												:height="memberLogTable.height"
												:total-records="memberLogTable.total"
												@headers="selectMemberLogHeaders"
												@reload="reloadMemberLogData"
											>
												<tr
													v-for="(item, key) in memberLogTable.items"
													:key="key"
													:class="{ 'cursor-pointer': true }"
													@contextmenu.prevent="editMemberLogClick(props.item.id, true)"
												>
													<td
														v-if="memberLogTable.selectedHeaders.includes('updated_at')"
														@click="editMemberLogClick(item.id, false)"
													>
														{{ item.updated_at }}
													</td>
													<td
														v-if="memberLogTable.selectedHeaders.includes('author')"
														@click="editMemberLogClick(item.id, false)"
													>
														{{ item.author }}
													</td>
													<td
														v-if="memberLogTable.selectedHeaders.includes('field')"
														@click="editMemberLogClick(item.id, false)"
													>
														{{ item.field }}
													</td>
													<td
														v-if="memberLogTable.selectedHeaders.includes('old_value')"
														@click="editMemberLogClick(item.id, false)"
													>
														{{ item.old_value }}
													</td>
													<td
														v-if="memberLogTable.selectedHeaders.includes('new_value')"
														@click="editMemberLogClick(item.id, false)"
													>
														{{ item.new_value }}
													</td>
												</tr>
											</TheTable>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-tab-item>
			</v-tabs>
		</v-row>
	</v-container>
</template>

<script>
import Member from '../../../models/Member';
import TheTable from '../../trinkets/TheTable';
import TextArea from '../../trinkets/TextArea';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import InputField from '../../trinkets/InputField';
import DatePicker from '@/components/trinkets/DatePicker';

export default {
	name: 'Member',
	components: { CheckBox, InputField, Dropdown, TextArea, DatePicker, TheTable },
	data: function () {
		return {
			tabId: 0,
			inEditMode: false,
			initialLoad: false,
			member: new Member({ id: this.$route.params.id }),
			memberValidation: new Member({}, true),
			genders: ['m', 'ž'],
			paymentsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.paymentFormDate'),
						value: 'date',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.paymentFormReferenceNumber'),
						value: 'reference_number',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.paymentFormCategory'),
						value: 'category',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.paymentForm'),
						value: 'payment_form_amount',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.payment'),
						value: 'payment_amount',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.paymentDate'),
						value: 'payment_date',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.excerpt'),
						value: 'excerpt',
						type: '',
						allowFilter: true,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
			memberLogTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'updated_at', type: 'date', allowFilter: true },
					{ text: this.$t('fields.person'), value: 'author', type: 'string', allowFilter: true },
					{ text: this.$t('fields.field'), value: 'field', type: 'string', allowFilter: true },
					{ text: this.$t('fields.oldValue'), value: 'old_value', type: 'string', allowFilter: true },
					{ text: this.$t('fields.newValue'), value: 'new_value', type: 'string', allowFilter: true },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'updated_at',
					descending: true,
				},
			},
			subscriptionsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: false, sortable: false },
					{
						text: this.$t('fields.magazine'),
						value: 'magazine_id',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.subscriptionTitle'),
						value: 'title',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.delivery'),
						value: 'delivery_type_id',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.subscriptionCollected'),
						value: 'collected',
						type: '',
						allowFilter: false,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
			paymentFormsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: false, sortable: false },
					{
						text: this.$t('fields.paymentFormCategory'),
						value: 'category',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.paymentFormReferenceNumber'),
						value: 'reference_number',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{ text: this.$t('fields.amount'), value: 'amount', type: '', allowFilter: false, sortable: false },
					{
						text: this.$t('fields.paymentFormReturned'),
						value: 'returned',
						type: '',
						allowFilter: false,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
			codebookDropdownKey: 0,
			newCodebookEntryShow: false,
			newCodebookEntryTable: null,
			newCodebookEntryValue: null,
		};
	},
	watch: {
		'member.membership_paid_until_date': {
			handler: function (newVal) {
				if (newVal != null) {
					this.member.membership_status_id = 4;
				}
			},
			deep: false,
		},
	},
	methods: {
		cancelEditClick() {
			this.inEditMode = false;
			this.getData();
		},
		updatePaymentStatus(item) {
			let vm = this;
			item.returned = !item.returned;
			this.$APICall(
				'post',
				'members-payment-status',
				{ paymentFormId: item.id },
				(data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicUpdate'));
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		editPaymentFormsClick(id, newTab = false) {
			/* if (!newTab) {
				this.$router.push('/payment/' + id);
			} else {
				let routeData = this.$router.resolve('/payment/' + id);
				window.open(routeData.href, '_blank');
			} */
		},
		selectPaymentFormsHeaders(headers) {
			this.paymentFormsTable.selectedHeaders = headers;
		},
		reloadPaymentFormsData(request) {
			this.paymentFormsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'member-payment-forms/' + this.member.id,
				request,
				(data, success) => {
					if (success) {
						vm.paymentFormsTable.items = data.items;
						vm.paymentFormsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolvePaymentFormsWindowResize() {
			this.paymentFormsTable.height = window.innerHeight - 500 + 'px';
		},
		editPaymentClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/payment/' + id);
			} else {
				let routeData = this.$router.resolve('/payment/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectPaymentHeaders(headers) {
			this.paymentsTable.selectedHeaders = headers;
		},
		reloadPaymentData(request) {
			this.paymentsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'member-payments/' + this.member.id,
				request,
				(data, success) => {
					if (success) {
						vm.paymentsTable.items = data.items;
						vm.paymentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolvePaymentWindowResize() {
			this.paymentsTable.height = window.innerHeight - 310 + 'px';
		},
		editMemberLogClick(id, newTab = false) {
			console.log(id);
		},
		selectMemberLogHeaders(headers) {
			this.memberLogTable.selectedHeaders = headers;
		},
		reloadMemberLogData(request) {
			this.memberLogTable.lastRequest = request;
			request.member_id = this.member.id;
			let vm = this;
			this.$APICall(
				'get',
				'members-log',
				request,
				(data, success) => {
					if (success) {
						vm.memberLogTable.items = data.items;
						vm.memberLogTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveMemberLogWindowResize() {
			this.memberLogTable.height = window.innerHeight - 310 + 'px';
		},
		selectSubscriptionHeaders(headers) {
			this.subscriptionsTable.selectedHeaders = headers;
		},
		reloadSubscriptionData(request) {
			this.subscriptionsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'subscriptions-member/' + this.member.id,
				request,
				(data, success) => {
					if (success) {
						vm.subscriptionsTable.items = data.items;
						vm.subscriptionsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveSubscriptionsWindowResize() {
			this.subscriptionsTable.height = window.innerHeight - 550 + 'px';
		},
		backClick() {
			this.$router.replace('/members');
		},
		saveClick() {
			let success = true;
			let errorTabId = null;

			if (
				this.member.membership_id == null ||
				this.member.membership_id == '' ||
				!/^\d+$/.test(this.member.membership_id)
			) {
				success = false;
				this.memberValidation.membership_id = false;
				errorTabId = 3;
			} else {
				this.memberValidation.membership_id = true;
			}
			if (this.member.membership_start_date_id == null || this.member.membership_start_date_id == '') {
				success = false;
				this.memberValidation.membership_start_date_id = false;
				errorTabId = 3;
			} else {
				this.memberValidation.membership_start_date_id = true;
			}
			if (this.member.membership_type_id == null || this.member.membership_type_id == '') {
				success = false;
				this.memberValidation.membership_type_id = false;
				errorTabId = 3;
			} else {
				this.memberValidation.membership_type_id = true;
			}
			if (this.member.membership_status_id == null || this.member.membership_status_id == '') {
				success = false;
				this.memberValidation.membership_status_id = false;
				errorTabId = 3;
			} else {
				this.memberValidation.membership_status_id = true;
			}
			if (this.member.branch_id == null || this.member.branch_id == '') {
				success = false;
				this.memberValidation.branch_id = false;
				errorTabId = 3;
			} else {
				this.memberValidation.branch_id = true;
			}
			if (this.member.magazine_id == null || this.member.magazine_id == '') {
				success = false;
				this.memberValidation.magazine_id = false;
				errorTabId = 3;
			} else {
				this.memberValidation.magazine_id = true;
			}
			if (this.member.country_id == null || this.member.country_id == '') {
				success = false;
				this.memberValidation.country_id = false;
				errorTabId = 1;
			} else {
				this.memberValidation.country_id = true;
			}
			if (this.member.city == null || this.member.city.trim() == '') {
				success = false;
				this.memberValidation.city = false;
				errorTabId = 1;
			} else {
				this.memberValidation.city = true;
			}
			if (this.member.zip_code == null || this.member.zip_code.trim() == '') {
				success = false;
				this.memberValidation.zip_code = false;
				errorTabId = 1;
			} else {
				this.memberValidation.zip_code = true;
			}
			if (this.member.first_name == null || this.member.first_name.trim() == '') {
				success = false;
				this.memberValidation.first_name = false;
				errorTabId = 0;
			} else {
				this.memberValidation.first_name = true;
			}
			if (this.member.last_name == null || this.member.last_name.trim() == '') {
				success = false;
				this.memberValidation.last_name = false;
				errorTabId = 0;
			} else {
				this.memberValidation.last_name = true;
			}
			if (this.member.gender == null || this.member.gender.trim() == '') {
				success = false;
				this.memberValidation.gender = false;
				errorTabId = 0;
			} else {
				this.memberValidation.gender = true;
			}
			if (this.member.date_of_birth == null || this.member.date_of_birth.trim() == '') {
				success = false;
				this.memberValidation.date_of_birth = false;
				errorTabId = 0;
			} else {
				this.memberValidation.date_of_birth = true;
			}
			if (this.member.place_of_birth == null || this.member.place_of_birth.trim() == '') {
				success = false;
				this.memberValidation.place_of_birth = false;
				errorTabId = 0;
			} else {
				this.memberValidation.place_of_birth = true;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.member.id != 0) {
					action = 'put';
					addition = '/' + vm.member.id;
				}
				this.$APICall(action, 'members' + addition, this.member, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.member.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				if (errorTabId != null) {
					this.tabId = errorTabId;
				}
			}
		},
		newCodebookEntryAddClick(entryTable) {
			this.newCodebookEntryTable = entryTable;
			this.newCodebookEntryShow = true;
		},
		newCodebookEntryClose() {
			this.newCodebookEntryTable = null;
			this.newCodebookEntryValue = null;
			this.newCodebookEntryShow = false;
		},
		newCodebookEntrySave() {
			let vm = this;
			this.$APICall(
				'post',
				'codebooks-data',
				{ table: this.newCodebookEntryTable, value: this.newCodebookEntryValue },
				(data, success) => {
					if (success) {
						vm.newCodebookEntryClose();
						vm.codebookDropdownKey += 1;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		getData() {
			let vm = this;
			this.$APICall('get', 'members/' + this.member.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.member = usableData;
					vm.$nextTick(() => {
						vm.initialLoad = true;
						vm.$myStore.commit('setBreadcrumbs', [
							{
								text: vm.$t('modules.members'),
								href: '/#/members',
								disabled: false,
							},
							{
								text: vm.member.first_name + ' ' + vm.member.last_name,
								href: '/#/members/' + vm.member.id,
								disabled: true,
							},
						]);
					});
				} else {
					this.$myStore.commit('setBreadcrumbs', [
						{ text: this.$t('modules.members'), href: '/#/members', disabled: false },
					]);
				}
			});
		},
		routeToBranch(branchId) {
			if (branchId) {
				let routeData = this.$router.resolve('/branches/' + branchId);
				window.open(routeData.href, '_blank');
			}
		},
		getNextMembershipId() {
			this.$APICall('get', 'new-membership-id', {}, (data, success) => {
				if (success) {
					if (data) {
						this.member.membership_id = data;
					}
				}
			});
		},
		toggleCollected(item){
			item.collected = !item.collected;
			this.$APICall('post','subscriptions-toggle-collected',{id: item.id},(data, success) => {});
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		if (this.member.id != 0) {
			this.getData();
		} else {
			this.getNextMembershipId();
			this.inEditMode = true;
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.members'),
					href: '/#/members',
					disabled: false,
				},
				{
					text: 'Novi član',
					href: '/#/members/' + this.member.id,
					disabled: true,
				},
			]);
		}
		window.addEventListener('resize', this.resolveWindowResize);
		this.resolvePaymentWindowResize();
		this.resolveMemberLogWindowResize();
		this.resolvePaymentFormsWindowResize();
		this.resolveSubscriptionsWindowResize();
	},
};
</script>

<style>
.module-tab {
	font-size: 0.75rem !important;
}

.add-icon {
	cursor: pointer;
}

.add-icon:hover {
	color: #009ec0;
}

.add-icon:active::after {
	background-color: transparent !important;
}

.module-top-name,
.module-top-branch,
.module-top-membership-id,
.module-top-status {
	display: block;
}

.module-top-name {
	font-size: 1.1rem;
	line-height: 1.1rem;
	font-weight: 500;
	color: rgb(34, 34, 34);
}

.module-top-branch {
	font-weight: 500;
	color: rgb(66, 66, 66);
}

.module-top-branch,
.module-top-membership-id,
.module-top-status {
	font-size: 0.9rem;
	line-height: 1rem;
}

.module-title {
	margin-left: 1.6vw;
	font-size: 1.2rem;
	line-height: 2.7rem;
	color: rgb(74, 74, 74);
}

.read-only-class input,
.read-only-class textarea,
.read-only-class span {
	color: rgb(88, 88, 88) !important;
	cursor: default;
}

.member-functions-entry,
.member-functions-title {
	display: block !important;
}

.member-functions-title {
	line-height: 1.5rem;
}

.member-functions-entry {
	cursor: pointer;
	color: rgb(66, 66, 66);
}

.member-functions-entry:hover {
	color: rgb(91, 91, 91);
}
</style>
